(() => {
  const MOBILE_QUERY = '(max-width: 749px)';
  const GALLERY_SELECTOR =
    '#MainContent > .shopify-section:first-child product-info .slider-mobile-gutter';

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function bindGallery(gallery) {
    if (!gallery || gallery.dataset.hyPdpProgressBound === 'true') return;

    const rail = gallery.querySelector('.product__media-list');
    const progress = gallery.querySelector(':scope > .slider-buttons');

    if (!rail || !progress) return;

    gallery.dataset.hyPdpProgressBound = 'true';

    function updateProgress() {
      if (!window.matchMedia(MOBILE_QUERY).matches) {
        progress.style.removeProperty('--hy-pdp-thumb-width');
        progress.style.removeProperty('--hy-pdp-thumb-x');
        progress.classList.remove('hy-mobile-pdp-progress--static');
        return;
      }

      const items = rail.querySelectorAll(
        ':scope > .product__media-item:not([hidden])'
      );
      const trackWidth = progress.clientWidth;
      const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);

      if (items.length <= 1 || !trackWidth || maxScroll <= 1) {
        progress.classList.add('hy-mobile-pdp-progress--static');
        progress.style.removeProperty('--hy-pdp-thumb-width');
        progress.style.removeProperty('--hy-pdp-thumb-x');
        return;
      }

      progress.classList.remove('hy-mobile-pdp-progress--static');

      let thumbWidth = trackWidth * (rail.clientWidth / rail.scrollWidth);
      thumbWidth = Math.max(120, Math.min(trackWidth, thumbWidth));

      const travel = Math.max(0, trackWidth - thumbWidth);
      const ratio = clamp(rail.scrollLeft / maxScroll, 0, 1);

      progress.style.setProperty('--hy-pdp-thumb-width', `${thumbWidth}px`);
      progress.style.setProperty('--hy-pdp-thumb-x', `${travel * ratio}px`);
    }

    rail.addEventListener('scroll', updateProgress, { passive: true });
    document.addEventListener('hy:colour-media-updated', updateProgress);

    if (typeof ResizeObserver !== 'undefined') {
      const resizeObserver = new ResizeObserver(updateProgress);
      resizeObserver.observe(rail);
      resizeObserver.observe(progress);
    }

    const mutationObserver = new MutationObserver(updateProgress);
    mutationObserver.observe(rail, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'hidden'],
    });

    rail.querySelectorAll('img').forEach((image) => {
      if (!image.complete) {
        image.addEventListener('load', updateProgress, { once: true });
      }
    });

    window.requestAnimationFrame(updateProgress);
    window.setTimeout(updateProgress, 150);
  }

  function initialize(root = document) {
    root.querySelectorAll(GALLERY_SELECTOR).forEach(bindGallery);
  }

  window.addEventListener('resize', () => initialize(), { passive: true });
  window.addEventListener('load', () => initialize(), { once: true });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
})();